import * as React from 'react';

/**
 * False during the server render and during the first client render (hydration), true right after.
 *
 * Anything that exists only in the browser (window, localStorage, client-only widgets) must not
 * change the markup of the first client render: it has to match the server HTML exactly, otherwise
 * React 18 discards the server HTML and re-renders the whole root. Gate such output on this flag
 * instead of `isSSR()` — `isSSR()` is already false during hydration, which is what breaks it.
 */
function useIsMounted() {
  const [isMounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  return isMounted;
}

export default useIsMounted;
